import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterAnexos(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/financeiro/anexos/pordespesa/${despesaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    baixarAnexo(anexo) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/financeiro/anexos/baixar/${anexo.despesaAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}